<template>
  <b-col md="12" sm="8">
    <b-card no-body class="mx-4">
      <b-card-header class="p-12">
        <b-row>
          <b-col cols="8">
            <label>Pergunta {{nomeComposto}}</label>
          </b-col>         
        </b-row>
      </b-card-header>
      <b-card-body class="p-4">
        <b-row>
          <b-col cols="12">
            <b-form-group :state="chkState('titulo')" invalid-feedback="Título da pergunta é obrigatório." class="mb-3">
              <vue-editor
                class="editor"
                :editorToolbar="customToolbar"
                v-model="pergunta.titulo"
                :disabled="visualizacao"
              ></vue-editor>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10">
            <b-form-group>
              <b-checkbox
                v-model="pergunta.possuiHint"
                :value="true"
                :disabled="visualizacao"
              >Desejo incluir uma dica</b-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="pergunta.possuiHint">
          <b-col cols="12">
            <b-form-group>
              <b-input-group class="mb-3">
                <b-form-input
                  type="text"
                  class="form-control"
                  placeholder="Dica sobre a pergunta"
                  :state="chkState('hint')"
                  :disabled="visualizacao"
                  v-model.trim="pergunta.hint"
                />
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                >Ao marcar "Desejo incluir uma dica" é necessário informar a dica.</b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <b-form-group>
              <b-form-group label="Tipo de resposta:">
                <b-form-select
                  v-model="pergunta.tipo"
                  :options="tipos"
                  :state="chkState('tipo')"
                  :disabled="visualizacao"
                ></b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback3">Tipo de resposta é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="Quantidade de caracteres" v-if="pergunta.tipo === 'TX'">
              <b-input-group class="mb-3">
                <b-form-input
                  type="number"
                  class="form-control"
                  :formater="formatSize"
                  placeholder="Quantidade de carateres limite do texto"
                  :state="chkState('size')"
                  :disabled="visualizacao"
                  v-model.trim="pergunta.size"
                />
                <b-form-invalid-feedback id="input1LiveFeedback3">Caso o "Tipo de resposta" seja "Texto livre" o campo "Quantidade de caracteres" é obrigatório.</b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group>
              <b-form-group label="Campo obrigatório:">
                <b-form-select
                  v-model="pergunta.required"
                  :options="opObrigatorio"
                  :state="chkState('required')"
                  :disabled="visualizacao"
                ></b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>
        <span v-if="pergunta.tipo === 'ME' || pergunta.tipo === 'UE'">
          <b-row v-for="(opcao, indexOpcao) in pergunta.opcoes" :key="indexOpcao">
            <b-col cols="8">
              <b-form-group :label="'Opção ' + (indexOpcao + 1)">
                <b-input-group class="mb-3">
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Opção"
                    :state="chkStateOpcoes(indexOpcao, 'resposta')"
                    :disabled="visualizacao"
                    v-model.trim="opcao.resposta"
                    v-on:keyup.enter="adicionaOpcao"
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Resposta é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="!visualizacao" class="botoes-opcoes">
              <b-button variant="primary" v-on:click="adicionaOpcao">
                <i class="fa fa-plus"></i>
              </b-button>
              <b-button
                variant="danger"
                v-if="pergunta.opcoes.length > 1"
                v-on:click="removeOpcao(indexOpcao)"
              >
                <i class="fa fa-minus"></i>
              </b-button>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <b-form-radio
                  :name="(nomeComposto) +'radioFlags'+ (indexOpcao + 1) + '-' + secao.ordemPergunta + '-' + pergunta.opcoes.length + '-' + uniqueId"
                  :id="(nomeComposto) +'radioFlagsFinaliza'+ (indexOpcao + 1) + '-' + secao.ordemPergunta + '-' + pergunta.opcoes.length + '-' + uniqueId"
                  v-model="opcao.finaliza"
                  :value="true"
                  v-on:change="mudaFinaliza(opcao)"
                  :disabled="visualizacao"
                >Esta resposta finaliza o formulário</b-form-radio>
                <b-form-radio
                  :name="(nomeComposto) +'radioFlags'+ (indexOpcao + 1) + '-' + secao.ordemPergunta + '-' + pergunta.opcoes.length + '-' + uniqueId"
                  :id="(nomeComposto) +'radioFlagsDependencia'+ (indexOpcao + 1) + '-' + secao.ordemPergunta + '-' + pergunta.opcoes.length + '-' + uniqueId"
                  v-model="opcao.possuiDependente"
                  :value="true"
                  v-on:change="mudaDependente(opcao)"
                  :disabled="visualizacao"
                >Desejo incluir uma pergunta para este item</b-form-radio>
                <b-form-radio
                  :name="(nomeComposto) +'radioFlags'+ (indexOpcao + 1) + '-' + secao.ordemPergunta + '-' + pergunta.opcoes.length + '-' + uniqueId"
                  :id="(nomeComposto) +'continuaForm'+ (indexOpcao + 1) + '-' + secao.ordemPergunta + '-' + pergunta.opcoes.length + '-' + uniqueId"
                  :checked="opcao.possuiDependente === false && opcao.finaliza === false ? true : false"
                  :value="true"
                  v-on:change="mudaContinuar(opcao)"
                  :disabled="visualizacao"
                >Continuar Preenchimento do Formulário</b-form-radio>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="opcao.possuiDependente === true">
              <pergunta
                v-for="(perguntaDependente, indexDependente) in opcao.pergunta"
                :key="indexDependente"
                :secao="opcao"
                :ref="'pergunta'"
                :pergunta="perguntaDependente"
                :posicao="indexDependente"
                :nomePai="(nomeComposto)"
                :visualizacao="visualizacao"
                :edicao="edicao"
                :vinculada="true"
                :salvarForm="salvarForm"
                :comprimento="opcao.pergunta.length"
              ></pergunta>
            </b-col>
          </b-row>
        </span>
        <b-row v-else>
          <b-col cols="12">
            <b-form-group>
              <b-form-radio
                :name="(nomeComposto) +'radioPerguntaFlags'+ (pergunta.ordem + 1) + '-' + secao.ordemPergunta + '-' + pergunta.pergunta.length + '-' + uniqueId"
                :id="(nomeComposto) +'radioFlagsFinaliza'+ (pergunta.ordem + 1) + '-' + secao.ordemPergunta + '-' + pergunta.pergunta.length + '-' + uniqueId"
                v-model="pergunta.finaliza"
                :value="true"
                v-on:change="mudaFinaliza(pergunta)"
                :disabled="visualizacao"
              >Esta resposta finaliza o formulário</b-form-radio>
              <b-form-radio
                :name="(nomeComposto) +'radioPerguntaFlags'+ (pergunta.ordem + 1) + '-' + secao.ordemPergunta + '-' + pergunta.pergunta.length + '-' + uniqueId"
                :id="(nomeComposto) +'radioFlagsDependencia'+ (pergunta.ordem + 1) + '-' + secao.ordemPergunta + '-' + pergunta.pergunta.length + '-' + uniqueId"
                v-model="pergunta.possuiDependente"
                :value="true"
                v-on:change="mudaDependente(pergunta)"
                :disabled="visualizacao"
              >Desejo incluir uma pergunta para este item</b-form-radio>
              <b-form-radio
                :name="(nomeComposto) +'radioPerguntaFlags'+ (pergunta.ordem + 1) + '-' + secao.ordemPergunta + '-' + pergunta.pergunta.length + '-' + uniqueId"
                :id="(nomeComposto) +'continuaForm'+ (pergunta.ordem + 1) + '-' + secao.ordemPergunta + '-' + pergunta.pergunta.length + '-' + uniqueId"
                :checked="pergunta.possuiDependente === false && pergunta.finaliza === false ? true : false"
                :value="true"
                v-on:change="mudaContinuar(pergunta)"
                :disabled="visualizacao"
              >Continuar Preenchimento do Formulário</b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="pergunta.possuiDependente === true">
            <pergunta
              v-for="(perguntaDependente, indexDependente) in pergunta.pergunta"
              :key="indexDependente"
              :secao="pergunta"
              :ref="'pergunta'"
              :pergunta="perguntaDependente"
              :posicao="indexDependente"
              :nomePai="(nomeComposto)"
              :vinculada="true"
              :visualizacao="visualizacao"
              :edicao="edicao"
              :salvarForm="salvarForm"
              :comprimento="pergunta.pergunta.length"
            ></pergunta>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-header class="p-12">
        <b-row>
         <b-col cols="8">
          </b-col>
          <b-col class="botoes-secao" v-if="!visualizacao && status !== 'SU'" cols="4">
            <b-button 
              class="btn-pergunta-actions" 
              variant="primary" 
              :disabled="disable_buttons" 
              title="Adicionar"
              v-on:click="adicionaPergunta()">
              <i class="fa fa-plus"></i>
            </b-button>
            <b-button
              class="btn-pergunta-actions"
              variant="danger"
              v-if="comprimento > 1"
              :disabled="visualizacao"
              title="Remover"
              v-on:click="removePergunta(posicao)"
            >
              <i class="fa fa-minus"></i>
            </b-button>
            <b-button
              class="btn-pergunta-actions"
              variant="secondary"
              :disabled="visualizacao"
              title="Duplicar"
              v-on:click="duplicaPergunta(posicao)"
            >
              <i class="fa fa-copy"></i>
            </b-button>

            <b-button
              class="btn-pergunta-actions"
              variant="secondary"
              :disabled="visualizacao"
              v-if="!vinculada"
              title="Descer"
              v-on:click="perguntaDown(posicao)"
            >
              <i class="fa fa-arrow-up"></i>
            </b-button>
            <b-button
              class="btn-pergunta-actions"
              variant="secondary"
              :disabled="visualizacao"
              v-if="!vinculada"
              title="Subir"
              v-on:click="perguntaUp(posicao)"
            >
              <i class="fa fa-arrow-down"></i>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
    </b-card>
  </b-col>
</template>

<script>
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { VueEditor } from 'vue2-editor'
import {
  required,
  requiredIf
} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import pergunta from '@/components/questionarios/Pergunta'

miniToastr.init()

export default {
  name: 'pergunta',
  props: {
    pergunta: [Array, Object],
    comprimento: Number,
    posicao: Number,
    visualizacao: Boolean,
    secao: Object,
    status: String,
    nomePai: [String, Number],
    edicao: Boolean,
    vinculada: Boolean,
    salvarForm: Boolean,
    ordenarSecao: Boolean,
    indexSecao: [String, Number]
  },
  components: {
    VueSelect,
    Multiselect,
    VueEditor,
    pergunta
  },
  mixins: [validationMixin],
  validations: {
    pergunta: {
      titulo: { required },
      hint: {
        required: requiredIf(function (pergunta) {
          return !pergunta.hint && pergunta.possuiHint
        })
      },
      tipo: { required },
      size: {
        required: requiredIf(function (pergunta) {
          return !pergunta.size && pergunta.tipo === 'TX'
        })
      },
      required: { required },
      opcoes: {
        $each: {
          resposta: { required }
        }
      }
    }
  },
  data () {
    return {
      disable_buttons: false,
      mudaFlag: '',
      tipos: [
        { value: '', text: 'Selecione o Tipo' },
        { value: 'CA', text: 'Câmera' },
        { value: 'CP', text: 'CEP' },
        { value: 'CF', text: 'CPF' },
        { value: 'CJ', text: 'CNPJ' },
        { value: 'DT', text: 'Data' },
        { value: 'HR', text: 'Horário' },
        { value: 'ME', text: 'Múltipla Seleção' },
        { value: 'ND', text: 'Número Decimal' },
        { value: 'NI', text: 'Número Inteiro' },
        { value: 'UE', text: 'Seleção Única' },
        { value: 'TE', text: 'Telefone' },
        { value: 'EM', text: 'E-mail' },
        { value: 'TX', text: 'Texto Livre' },
        { value: 'UP', text: 'Upload' },
        { value: 'UM', text: 'UF / Município' }
      ],
      opObrigatorio: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false }
      ],
      customToolbar: [
        [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{'script': 'sub'}, { 'script': 'super' }],
        [{'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        ['link', 'image', 'video', 'formula'],
        ['clean']]
    }
  },
  mounted () {
    this.pergunta.setEdit = false
    if (this.ordenarSecao) {
      this.$emit('setaOrdenar', this.indexSecao)
    }
  },
  computed: {
    nomeComposto () {
      var nome = ''
      nome =
        this.nomePai
          ? this.nomePai + '.' + (this.posicao + 1)
          : this.posicao + 1
      return nome
    },
    uniqueId () {
      var max = 999999999
      var min = 1
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    perguntaDuplicar () {
      return this.pergunta
    }
  },
  watch: {
    'pergunta.tipo': function () {
      // verifica se é multipla escolha ou escolha unica para adicionar uma opção
      if (this.pergunta.tipo === 'ME' || this.pergunta.tipo === 'UE') {
        // caso seja o momento do set dos atributos vindos do banco ele não adiciona opção
        if (!this.pergunta.setEdit && !this.ordenarSecao) {
          this.pergunta.opcoes.push({
            resposta: '',
            finaliza: false,
            possuiDependente: false,
            ordemPergunta: 1,
            pergunta: [
              {
                titulo: '',
                ordem: 1,
                hint: '',
                possuiHint: false,
                tipo: '',
                size: '',
                finaliza: '',
                possuiDependente: '',
                required: false,
                opcoes: [],
                pergunta: []
              }
            ]
          })
        } else {
          this.pergunta.setEdit = false
          if (this.ordenarSecao) {
            this.$emit('setaOrdenar', this.indexSecao)
          }
        }
      } else {
        // zera as opções para remover lixos
        this.pergunta.opcoes = []
      }

      if (this.pergunta.tipo !== 'TX') {
        // zera o size para remover lixos
        this.pergunta.size = ''
      }
    },
    'pergunta.possuiDependente': function () {
      if (this.pergunta.possuiDependente === true) {
        if (!this.pergunta.setEdit && !this.ordenarSecao) {
          this.pergunta.pergunta.push({
            titulo: '',
            ordem: 1,
            hint: '',
            possuiHint: false,
            tipo: '',
            size: '',
            finaliza: '',
            possuiDependente: '',
            required: false,
            opcoes: [],
            pergunta: []
          })
        } else {
          this.pergunta.setEdit = false
          if (this.ordenarSecao) {
            this.$emit('setaOrdenar', this.indexSecao)
          }
        }
      } else {
        this.pergunta.setEdit = false
        this.pergunta.pergunta = []
      }
    },
    'salvarForm': function () {
      if (this.salvarForm) {
        this.validate()
      }
    }
  },
  methods: {
    adicionaPergunta () {
      this.secao.ordemPergunta = this.secao.pergunta.length + 1
      this.secao.pergunta.push({
        titulo: '',
        ordem: this.secao.ordemPergunta,
        hint: '',
        possuiHint: false,
        tipo: '',
        size: '',
        finaliza: '',
        possuiDependente: '',
        required: false,
        opcoes: [],
        pergunta: []
      })
    },
    formatSize (e) {
      return String(e).substring(0, 9999)
    },
    removePergunta (index) {
      this.$delete(this.secao.pergunta, index)
      this.secao.ordemPergunta = this.secao.ordemPergunta - 1

      console.log(index < this.secao.pergunta.length)
      if (index < this.secao.pergunta.length) {
        for (let p in this.secao.pergunta) {
          console.log('Reacting')
          if (this.secao.pergunta[p].ordem > index) {
            this.secao.pergunta[p].ordem = this.secao.pergunta[p].ordem - 1
          }
        }
      }
    },
    perguntaUp (perguntaIndex) {
      this.ordena(this.secao.pergunta, perguntaIndex, +1)
    },
    perguntaDown (perguntaIndex) {
      this.ordena(this.secao.pergunta, perguntaIndex, -1)
    },
    duplicaPergunta (perguntaIndex) {
      this.secao.ordemPergunta = this.secao.pergunta.length + 1

      this.secao.pergunta.push({
        titulo: this.perguntaDuplicar.titulo,
        ordem: this.secao.ordemPergunta,
        possuiHint: this.perguntaDuplicar.possuiHint,
        hint: this.perguntaDuplicar.hint,
        tipo: this.perguntaDuplicar.tipo,
        size: this.perguntaDuplicar.size,
        finaliza: this.perguntaDuplicar.finaliza,
        possuiDependente: this.perguntaDuplicar.possuiDependente,
        pergunta: [],
        opcoes: [],
        required: this.perguntaDuplicar.required
      })

      let posicao = this.secao.pergunta.length - 1

      this.perguntaDuplicar.pergunta.forEach((perguntaDependente) => {
        this.setDuplicaPergunta(perguntaDependente, this.secao.pergunta[posicao].pergunta)
      })

      this.perguntaDuplicar.opcoes.forEach(element => {
        this.secao.pergunta[posicao].opcoes.push({
          resposta: element.resposta,
          finaliza: element.finaliza,
          possuiDependente: element.possuiDependente,
          ordemPergunta: element.ordemPergunta,
          pergunta: []
        })

        element.pergunta.forEach((perguntaDependente) => {
          this.setDuplicaPergunta(perguntaDependente, this.secao.pergunta[posicao].opcoes[(this.secao.pergunta[posicao].opcoes.length - 1)].pergunta)
        })
      })
    },
    setDuplicaPergunta (pergunta, array) {
      array.push({
        titulo: pergunta.titulo,
        ordem: pergunta.ordem,
        possuiHint: pergunta.possuiHint,
        hint: pergunta.hint,
        tipo: pergunta.tipo,
        finaliza: pergunta.finaliza,
        possuiDependente: pergunta.possuiDependente,
        size: pergunta.size,
        required: pergunta.required,
        pergunta: [],
        opcoes: []
      })

      pergunta.opcoes.forEach((opcao) => {
        array[(array.length - 1)].opcoes.push({
          resposta: opcao.resposta,
          finaliza: opcao.finaliza,
          possuiDependente: opcao.possuiDependente,
          ordemPergunta: opcao.pergunta.length,
          pergunta: []
        })

        opcao.pergunta.forEach((perguntaDependente) => {
          this.setDuplicaPergunta(perguntaDependente, array[(array.length - 1)].opcoes[(array[(array.length - 1)].opcoes.length - 1)].pergunta)
        })
      })

      pergunta.pergunta.forEach((perguntaDependente) => {
        this.setDuplicaPergunta(perguntaDependente, array[(array.length - 1)].pergunta)
      })
    },
    adicionaOpcao () {
      this.pergunta.opcoes.push({
        resposta: '',
        finaliza: false,
        possuiDependente: false,
        ordemPergunta: 1,
        pergunta: [
          {
            titulo: '',
            ordem: 1,
            hint: '',
            possuiHint: false,
            tipo: '',
            size: '',
            finaliza: '',
            possuiDependente: '',
            required: false,
            opcoes: [],
            pergunta: []
          }
        ]
      })
    },
    removeOpcao (index) {
      this.$delete(this.pergunta.opcoes, index)
    },
    ordena (array, index, delta) {
      var newIndex = index + delta
      if (newIndex < 0 || newIndex === array.length) return
      var indexes = [index, newIndex].sort((a, b) => a - b)
      array[index].ordem = newIndex + 1
      array[index].setEdit = true // impede os watchers de manipularem
      array[newIndex].ordem = array[newIndex].ordem - delta
      array[newIndex].setEdit = true // impede os watchers de manipularem
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]])
    },
    mudaFinaliza (opcao) {
      opcao.finaliza = true
      opcao.possuiDependente = false
    },
    mudaDependente (opcao) {
      if (!opcao.pergunta.length) {
        opcao.pergunta.push({
          titulo: '',
          ordem: 1,
          hint: '',
          possuiHint: false,
          tipo: '',
          size: '',
          finaliza: '',
          possuiDependente: '',
          required: false,
          opcoes: [],
          pergunta: []
        })
      }
      opcao.finaliza = false
      opcao.possuiDependente = true
    },
    mudaContinuar (opcao) {
      opcao.finaliza = false
      opcao.possuiDependente = false
    },
    chkState (val) {
      if (!this.visualizacao) {
        const field = this.$v.pergunta[val]
        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    chkStateOpcoes (index, val) {
      if (!this.visualizacao) {
        const field = this.$v.pergunta.opcoes.$each.$iter[index][val]
        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }

        component.$el.scrollIntoView({behavior: 'smooth'})
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.findFirstError()
    }
  }
}
</script>

<style scoped>
.botoes-secao {
  text-align: right;
}

.btn-pergunta-actions {
  text-align: center;
  width: 27px;
  height: 25px;
  padding: 2px 2px 2px 2px;
}

.editor {
  margin-top: 1%;
}
.botoes-opcoes {
  padding-top: 27px;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/questionarios/Pergunta.vue